/* eslint-disable jsx-a11y/alt-text */
import React, { FC, useEffect, useState } from 'react';
import Image, { ImageProps } from 'next/image';

const ImageWithFallback: FC<
  ImageProps & {
    fallback?: ImageProps['src'];
    hideOnFail?: boolean;
  }
> = ({ src, fallback, hideOnFail = true, ...rest }) => {
  const [source, setSource] = useState(src);
  const [hidden, setHidden] = useState(false);
  useEffect(() => {
    setSource(src);
    setHidden(false);
  }, [src]);

  return (
    <>
      {!!source && !hidden && (
        <Image
          {...rest}
          src={source}
          onError={() => {
            fallback && source !== fallback
              ? setSource(fallback)
              : setHidden(true);
          }}
        />
      )}
    </>
  );
};

export default ImageWithFallback;
